import React from "react";

/** 호버 시 앞으로 밀리는 화살표 — CTA에서 반복해 쓰는 조각 */
export default function ArrowRight({ className = "h-4 w-4" }) {
	return (
		<svg
			className={`${className} transition-transform duration-300 group-hover:translate-x-1`}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			aria-hidden="true"
		>
			<path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
